import React from 'react';

const EmptyStateCard = ({
  title = 'No records available',
  subtitle = 'No records available for the selected reporting period.',
}) => (
  <div className="sm-empty" role="status">
    <div className="sm-empty__icon" aria-hidden>
      ◇
    </div>
    <p className="sm-empty__title">{title}</p>
    <p className="sm-empty__subtitle">{subtitle}</p>
  </div>
);

export default EmptyStateCard;
